import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { Button2Component } from '@frontendlib/components/components/button/button2.component';

@Component({
  standalone: true,
  selector: 'app-close-component',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Button2Component, IconComponent],
  template: `<app-button2 appearance="secondary-ghost" size="s">
    <app-icon name="close" />
  </app-button2> `,
})
export class CloseButtonComponent {}
